import { gsap, Power2 }   from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

document.querySelector('footer .scrolltop').addEventListener('click', (e) =>
{
	e.preventDefault()
	
	gsap.to(window, {
		scrollTo: 0,
		duration: .5,
		ease: Power2.easeOut
	})
})

const headerScrolls = document.querySelectorAll('header .scroll')

headerScrolls.forEach(el =>
{
	el.addEventListener('click', e =>
	{
		e.preventDefault()
		
		const offset = getOffset(el.closest('header').nextElementSibling)
		
		gsap.to(window, {
			scrollTo: offset.y - 60,
			duration: .5,
			ease: Power2.easeOut
		})
	})
})

const sectionScrolls = document.querySelectorAll('section[data-text_photo] .scroll')

sectionScrolls.forEach(el =>
{
	el.addEventListener('click', e =>
	{
		e.preventDefault()
		
		const offset = getOffset(el.closest('section').nextElementSibling)
		
		gsap.to(window, {
			scrollTo: offset.y - 60,
			duration: .5,
			ease: Power2.easeOut
		})
	})
})

function getOffset (el)
{
	let xPos = 0
	let yPos = 0
	
	while (el)
	{
		if (el.tagName === 'body')
		{
			const xScroll = el.scrollLeft || document.documentElement.scrollLeft
			const yScroll = el.scrollTop || document.documentElement.scrollTop
			
			xPos += (el.offsetLeft - xScroll + el.clientLeft)
			yPos += (el.offsetTop - yScroll + el.clientTop)
		}
		else
		{
			xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft)
			yPos += (el.offsetTop - el.scrollTop + el.clientTop)
		}
		
		el = el.offsetParent
	}
	return {
		x: xPos,
		y: yPos
	}
}
